import { ProductDetailsResponse, ProductRole } from '@/@types/Products';
import CustomSheet from '@/components/shared/Sheet/Sheet';
import useModalStore from '@/store/useModalStore';
import { useOutletContext, useParams } from 'react-router-dom';
import { useFetchAffiliateProgram } from './hooks/useFetchAffiliateProgram';
import AffiliateList from './Partials/AffiliateList';
import SideQuickCreate from './Partials/SideQuickCreate';
import { usePermissions } from '@/auth/PermissionsContext';

export default function Affiliate() {
  const { id } = useParams<{ id: string }>();
  const { modals, closeModal } = useModalStore();
  const { hasPermission } = usePermissions();
  const canConfigureProgram = hasPermission('affiliates.configure_affiliate_program');

  const { affiliateProgram, isLoading } = useFetchAffiliateProgram(id || '');

  if (!id) {
    return null;
  }

  return (
    <>
      <div className='space-y-6'>
        <AffiliateList
          active={affiliateProgram?.data?.enable_affiliate_program ?? false}
          requestedOnMarketplace={affiliateProgram?.data?.requested_on_marketplace}
        />
      </div>

      {canConfigureProgram && (
        <CustomSheet
          open={modals['config-affiliate']}
          onClose={() => closeModal('config-affiliate')}
        >
          <SideQuickCreate
            productId={id}
            affiliateProgram={affiliateProgram}
            isLoading={isLoading}
          />
        </CustomSheet>
      )}
    </>
  );
}
